import {isNullOrUndefined} from "./null.utils";

function isInternetExplorer () :boolean {
    return !isNullOrUndefined((window.document as any).documentMode);
}

export{
    isInternetExplorer
}